"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _merge = _interopRequireDefault(require("lodash/merge"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactLazyLoad = _interopRequireDefault(require("react-lazy-load"));

(function () {
  var enterModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).enterModule;
  enterModule && enterModule(module);
})();

var Image = function Image(_ref) {
  var className = _ref.className,
      lazyLoad = _ref.lazyLoad,
      lazyLoadOffsetVertical = _ref.lazyLoadOffsetVertical,
      onLoad = _ref.onLoad,
      imgAttributes = (0, _objectWithoutProperties2.default)(_ref, ["className", "lazyLoad", "lazyLoadOffsetVertical", "onLoad"]);
  var classes = (0, _classnames.default)(className, 'Image', {
    'Image-loaded': !lazyLoad
  });
  var attrs = (0, _merge.default)({
    className: classes
  }, imgAttributes);

  if (lazyLoad) {
    return _react.default.createElement(_reactLazyLoad.default, {
      offsetVertical: lazyLoadOffsetVertical
    }, _react.default.createElement("img", (0, _extends2.default)({}, attrs, {
      onLoad: onLoad
    })));
  }

  return _react.default.createElement("img", (0, _extends2.default)({}, attrs, {
    onLoad: onLoad
  }));
};

Image.propTypes = {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** Whether to use lazy loading for this image. */
  lazyLoad: _propTypes.default.bool,

  /** The offset from the bottom of the screen at which point the image gets lazy loaded when the page is scrolled to. */
  lazyLoadOffsetVertical: _propTypes.default.number,

  /** Optional function to execute when the image is loaded. */
  onLoad: _propTypes.default.func
};
Image.defaultProps = {
  lazyLoad: false,
  lazyLoadOffsetVertical: 100
};
var _default = Image;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).default;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Image, "Image", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Image/Image.jsx");
  reactHotLoader.register(_default, "default", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Image/Image.jsx");
})();

;

(function () {
  var leaveModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).leaveModule;
  leaveModule && leaveModule(module);
})();